<mat-card>
  <mat-card-header>
    <mat-card-title>Medicare GEO</mat-card-title>
    <mat-card-subtitle>Add Medicare GEO</mat-card-subtitle>
  </mat-card-header>
  <form>
    <mat-form-field class="search-medicare-field" floatLabel="never">
      <mat-icon matSuffix matTooltip="Search by State">search</mat-icon>
      <input
        type="text"
        matInput
        [formControl]="searchInput"
        [matAutocomplete]="auto"
        placeholder="Search Medicare GEO"
      />
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="getOptionText">
        <mat-option *ngFor="let option of filteredOptions" [value]="option" matTooltip="{{ option.state }}">
          <div>
            <div>
              <div>
                {{ option.state }} ({{ option.medicare_administrative_contractor }}) - {{ option.locality_number }}
              </div>
            </div>
          </div>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </form>
  <mat-card-actions>
    <div class="actionsButton">
      <button mat-raised-button color="primary" type="button" (click)="save()">Save</button>
    </div>
  </mat-card-actions>
</mat-card>
